<template>
    <v-row row wrap>

        <v-col cols="12" sm="6" md="4" offset-md="8" offset-sm="6">
            <search-input @search="performSearch" v-model="search" />
        </v-col>

        <v-col cols="12">

            <div class="table-fixed-header-wrap">
            <v-data-table
                class="mt-3"
                fixed-header
                height="calc(100vh - 260px)"
                :headers="headers"
                :items="items"
                :single-expand="false"
                :server-items-length="totalItems"
                :loading="loading"
                :page.sync="pageNumber"
                :items-per-page.sync="itemsPerPage"
                :sort-by.sync="orderBy"
                :sort-desc.sync="orderDesc"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                @update:page="fetch"
                @update:sort-by="fetch"
                @update:sort-desc="fetch"
                @update:items-per-page="fetch"
            >

                <template slot="no-data">
                    <div class="text-xs-center" v-t="'common.noData'"></div>
                </template>

                <template slot="loading">
                    <div class="text-xs-center" v-t="'common.loading'"></div>
                </template>

                <template v-slot:item.condicionIVA="{ item }">
                    {{ condicionIVALabel(item.condicionIVA) }}
                </template>

                <template v-slot:item.deuda="{ item }">
                    <div class="text-center">
                        <template v-if="item.deuda != null && Number(item.deuda) > 0">
                            <span class="error--text font-weight-medium">${{ Number(item.deuda).toFixed(2) }}</span>
                        </template>
                        <v-icon v-else small color="success">mdi-check-circle</v-icon>
                    </div>
                </template>

                <template v-slot:item.action="{ item }">
                    <show-button @click="$emit('show', item)" />
                    <edit-button @click="$emit('update', item)" />
                    <!-- <delete-button @click="$emit('delete', item)" /> -->
                </template>

            </v-data-table>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import ClienteProvider from "../../../providers/ClienteProvider";

import { EditButton, ShowButton, SearchInput } from "@dracul/common-frontend"


export default {
    name: "ClienteList",
    components: { EditButton, ShowButton, SearchInput },

    data() {
        return {
            items: [],
            totalItems: 0,
            loading: false,
            orderBy: ['razonSocial'],
            orderDesc: [false],
            itemsPerPage: 10,
            pageNumber: 1,
            search: ''
        }
    },
    computed: {
        headers() {
            return [
                //Entity Headers
                { text: this.$t('cliente.labels.razonSocial'), value: 'razonSocial' },
                { text: this.$t('cliente.labels.tipoDocumento'), value: 'tipoDocumento' },
                { text: this.$t('cliente.labels.numeroDocumento'), value: 'numeroDocumento' },
                { text: this.$t('cliente.labels.condicionIVA'), value: 'condicionIVA' },
                { text: this.$t('cliente.labels.email'), value: 'email' },
                { text: this.$t('cliente.labels.telefono'), value: 'telefono' },
                { text: 'Deuda', value: 'deuda', sortable: false, align: 'center' },
                //Actions
                { text: this.$t('common.actions'), value: 'action', sortable: false },
            ]
        },
        getOrderBy() {
            return (Array.isArray(this.orderBy)) ? this.orderBy[0] : this.orderBy
        },
        getOrderDesc() {
            return (Array.isArray(this.orderDesc)) ? this.orderDesc[0] : this.orderDesc
        }
    },
    created() {
        this.fetch()
    },
    methods: {
        condicionIVALabel(value) {
            if (!value) return "—";
            const labels = {
                CONSUMIDOR_FINAL: "Consumidor Final",
                RESPONSABLE_INSCRIPTO: "Responsable Inscripto",
                EXENTO: "Exento (IVA)",
                MONOTRIBUTISTA: "Monotributista",
                MONOTRIBUTO: "Monotributista",
                SUJETO_NO_CATEGORIZADO: "No responsable / Sujeto no categorizado",
            };
            return labels[value] || value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
        },
        performSearch() {
            this.pageNumber = 1
            this.fetch()
        },
        fetch() {
            this.loading = true
            ClienteProvider.paginateClientes(
                this.pageNumber,
                this.itemsPerPage,
                this.search || null,
                this.getOrderBy || 'razonSocial',
                this.getOrderDesc === true
            ).then(r => {
                const p = r.data && r.data.clientePaginate
                this.items = (p && p.items) || []
                this.totalItems = (p && p.totalItems) || 0
            }).catch(err => {
                console.error(err)
            }).finally(() => this.loading = false)
        }
    }

}
</script>

<style scoped>
.table-fixed-header-wrap {
  min-height: 0;
}
</style>
